/**
 * @generated SignedSource<<cfb850a7175b8d63d4042a6a745b6a3e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_upgradeOnboardingExperiment_UpgradeOnboardingModal$data = {
  readonly experienceUrl: string | null | undefined;
  readonly " $fragmentType": "main_upgradeOnboardingExperiment_UpgradeOnboardingModal";
};
export type main_upgradeOnboardingExperiment_UpgradeOnboardingModal$key = {
  readonly " $data"?: main_upgradeOnboardingExperiment_UpgradeOnboardingModal$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_upgradeOnboardingExperiment_UpgradeOnboardingModal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_upgradeOnboardingExperiment_UpgradeOnboardingModal",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "experienceUrl"
    }
  ],
  "type": "CommerceExperienceCapability",
  "abstractKey": "__isCommerceExperienceCapability"
};

(node as any).hash = "33c989c1d58b8c6208a2d186e1f942e8";

export default node;
